<div class="header">
  <div class="header-cont">
    <h2>{{ '404_page.title' | translate }}</h2>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div [innerHTML]="'404_page.descr' | translate"></div>
    <ul>
        <li>{{ '404_page.list.home' | translate }}<a [routerLink]="['/home']">{{ '404_page.list.home_link' | translate }}</a></li>
        <li>{{ '404_page.list.poi' | translate }}<a [routerLink]="['/home/poi']">{{ '404_page.list.poi_link' | translate }}</a></li>
        <li>{{ '404_page.list.itin' | translate }}<a [routerLink]="['/home/itinerari']">{{ '404_page.list.itin_link' | translate }}</a></li>
    </ul>
  </div>
</div>